import { GridRowModel } from "@mui/x-data-grid-pro";

import { PropertyLocationField } from "./PropertyLocationField";

interface PropertyLocationFormFieldProps {
  row?: GridRowModel;
}

// Adapter that mounts PropertyLocationField inside the Configuration edit form.
// The property id comes from the edited row (it is not part of the formik
// values), so on creation (no row yet) we render nothing — a location can only
// be attached to an existing property.
export const PropertyLocationFormField = ({
  row,
}: PropertyLocationFormFieldProps) => {
  if (row?.id == null) {
    return null;
  }
  const propertyId = Number(row.id);
  if (!Number.isInteger(propertyId)) {
    return null;
  }
  const propertyName = String(
    row.hebergement_nom_long ?? row.hebergement_nom_court ?? ""
  );
  return (
    <PropertyLocationField
      propertyId={propertyId}
      propertyName={propertyName}
    />
  );
};
